<script setup lang="ts">
import type { ProfileItem } from '@/components/ProfileGrid.vue';
import type { PropType } from '@vue/runtime-core';

const props = defineProps({
  item: {
    type: null as any as PropType<ProfileItem>,
  },
});
</script>

<template>
  <Modal>
    <div class="profile-modal-content" v-if="props.item">
      <div
        class="image"
        :style="`--profile-bg-image: url('${props.item.photo}')`"
      ></div>
      <div class="text">
        <div class="title">{{ props.item.title }}</div>
        <div class="name">{{ props.item.name }}</div>
        <div class="qualification">{{ props.item.qualifications }}</div>
        <HorizontalRule class="my-4" />
        <p class="intro">{{ props.item.intro }}</p>
      </div>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
@import '@/assets/css/variables';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

::v-deep(.modal-container) {
  height: 100%;
  width: 100%;
  max-height: 800px;
  max-width: 1200px;

  @include media-breakpoint-down(md) {
    border-radius: 0;
    max-height: unset;
    max-width: unset;
  }
}

::v-deep(.closeBtn) {
  color: $primary;

  @include media-breakpoint-down(md) {
    svg {
      width: 48px;
      height: 48px;
    }
  }
}

.profile-modal-content {
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;

  > * {
    height: 100%;
  }

  @include media-breakpoint-down(md) {
    overflow-y: auto;

    > * {
      width: 100%;
    }
  }

  .text {
    padding: 90px 70px 90px 140px;
    width: 55%;
    display: flex;
    flex-direction: column;

    @include media-breakpoint-down(lg) {
      padding: 48px;
    }

    @include media-breakpoint-down(sm) {
      width: 100%;
      height: unset;
      padding: 24px;
    }
  }

  .image {
    width: 45%;
    background-color: var(--bs-gray-300);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: var(--profile-bg-image);
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;

    @include media-breakpoint-down(md) {
      height: min(100vw, 400px);
      width: 100%;
      background-size: contain;
      border-radius: 0;
    }
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
    color: $primary;
  }

  .name {
    font-size: 35px;
    font-weight: 700;
  }

  .qualification {
    font-size: 18px;
    font-weight: 600;
    white-space: pre-wrap;
  }

  .intro {
    white-space: pre-wrap;
    font-size: 18px;
    font-weight: 500;
    overflow-y: auto;
    flex-grow: 1;
  }
}
</style>
